module.exports = __webpack_public_path__ + "img/Women’s Probiotic.c1aac459.png";